import React, { useState, useEffect } from "react";
import { Grid, TextField, Checkbox } from "@mui/material";
import SliderAuth from "../../../components/SliderAuth/SliderAuth";
import { InputAdornment } from '@mui/material';
import Loader from "../../../components/Loader/Loader";
import PrivacyPolicy from "../../../components/Privacy/Privacy";
import { images } from "../../../config/images";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Button } from "../../../components/Button/button";
import { signInApi } from "../service";
import { setUserDetails } from "../slice/userSlice";
import { clearStore } from "../../../redux/ClearStore/clearStore";
import ReCAPTCHA from "react-google-recaptcha";
import { notifyError } from "../../../components/ToastNotification/ToastNotification";
import MfaVerification from "./MfaVerification";
import TwoStepVerificationOTP from "./TwoStepVerificationOTP";

const LoginWithPasswordForm = ({ email, onCancelClick, onNextClick, setMfaUserId, setMFAVerifyEmail, setOTPVerifyMobileNo }) => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { userName } = useSelector((state) => state.userLoginSlice);

    const [isLoading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [isChecked, setIsChecked] = useState(false);
    const [Sitekey, setSitekey] = useState(
        "6Lf-TIsqAAAAAOYB1YoDM243ZXmaAInp1tPNh3EK"
    );
    const [isRecaptchaValid, setRecaptchaValid] = useState(false);

    const [render, setRender] = useState("Password");

    const [formvalues, setFormvalue] = useState({
        password: "",
    });

    const handleChange = (e) => {
        setFormvalue({ ...formvalues, [e.target.name]: e.target.value });
    };

    const handleTogglePasswordVisibility = () => {
        setShowPassword((prevShowPassword) => !prevShowPassword);
    };

    const encryptPassword = async (password) => {
        // Using Web Crypto API to replicate Python's PBKDF2 implementation
        const encoder = new TextEncoder();
        const salt = "wUSaq3zAOY9ddYZNFDYqIr"; // This should match backend's settings.DJANGO_PASSWORD_SALT
        const iterations = 320000;
        
        const passwordBuffer = encoder.encode(password);
        const saltBuffer = encoder.encode(salt);
        
        const keyBuffer = await crypto.subtle.importKey(
            'raw',
            passwordBuffer,
            { name: 'PBKDF2' },
            false,
            ['deriveBits']
        );
        
        const derivedBits = await crypto.subtle.deriveBits(
            {
                name: 'PBKDF2',
                salt: saltBuffer,
                iterations: iterations,
                hash: 'SHA-256',
            },
            keyBuffer,
            256 // 32 bytes = 256 bits
        );
        
        // Convert to Base64
        const hashArray = Array.from(new Uint8Array(derivedBits));
        const hashBase64 = btoa(String.fromCharCode.apply(null, hashArray));
        
        return `pbkdf2_sha256$${iterations}$${salt}$${hashBase64}`;
    };

    const handleLoginWithPassword = async () => {
        if (!formvalues.password) {
            notifyError("Please enter valid password.");
            return true;
        };
        setLoading(true);
        
        try {
            const encryptedPassword = await encryptPassword(formvalues.password);
            const params = {
                email: email,
                password: encryptedPassword,
                // password: formvalues.password,
            };

            const response = await signInApi(params);
            console.log("response", response);
            setLoading(false);

            if (
                response.data.message ==
                "Your MFA verification is enabled. Please verify to complete login."
            ) {
                setMFAVerifyEmail(response.data.payload.email);
                setMfaUserId(response.data.payload.mfa_user_id);
                onNextClick("verifyMFA");
                return true;
            }
            if (
                response.data.message ==
                "Your 2-Step verification is enabled. Please verify to complete login."
            ) {
                setOTPVerifyMobileNo(response.data.payload.mobile_number);
                onNextClick("verify2Step");
                return true;
            }

            if (response.data.message == "User logged in successfully.") {

                if (userName != formvalues.email) {
                    dispatch(clearStore());
                }
                navigate("/");
                dispatch(
                    setUserDetails({
                        firstName: response.data.payload.first_name,
                        lastName: response.data.payload.last_name,
                        email: response.data.payload.email,
                        mobileNoRe: response.data.payload.mobile_number,
                        token: response.data.payload.token,
                        id: response.data.payload.id,
                        MFA_UserId: response.data.payload.mfa_user_id,
                        company_logo: response.data.payload.company_logo,
                        companyId: response.data.payload.company_id,
                        is_super_admin: response.data.payload.is_super_admin,
                        is_admin: response.data.payload.is_admin,
                        companyName: response.data.payload.company_name,
                        companyDescription: response.data.payload.company_description,
                        user_access:
                            response.data.payload.user_access?.access_module_management || [],
                        company_access: response.data.payload.user_access?.company_access || [],
                        plant_access: response.data.payload.user_access?.plant_access || [],
                        user_country: response.data.payload.user_country,
                        user_country_name: response.data.payload.user_country_name,
                        user_country_code_name:
                            response.data.payload.user_country_code_name,
                        user_country_code: response.data.payload.user_country_code,
                        user_country_currency: response.data.payload.user_country_currency,
                        user_country_currency_name:
                            response.data.payload.user_country_currency_name,
                        user_country_currency_symbol:
                            response.data.payload.user_country_currency_symbol,
                        is_created_by_super_admin_user_company:
                            response.data.payload.is_created_by_super_admin_user_company,
                        is_renewable_energy: response.data.payload.is_renewable_energy
                    })
                );

                if (isChecked) {
                    // Save emmail to storage (sessionStorage)
                    const userData = { email: response.data.payload.email };
                    sessionStorage.setItem("user", JSON.stringify(userData));
                }
            }

        } catch (error) {
            console.log("error", error);
            setLoading(false);
            if (error.response.data.message) {
                notifyError(error.response.data.message);
            }

        }
    };

    const Recaptchahandle = (value) => {
        if (value) {
            setRecaptchaValid(true); // Set reCAPTCHA as valid
        } else {
            setRecaptchaValid(false); // Reset if reCAPTCHA is cleared
        }
    };
    return (
        <>
            <Grid container className="main-container">
                <SliderAuth />
                <Grid item size={{ xs: 12, md: 5, lg: 4 }} className="signIn-form-wrap">
                    <div className="pb-2">
                        <img src={images.logo} alt="" className="signIn-logo" />
                    </div>
                    <h3 className="text-center singIn-title">Welcome</h3>
                    <p className="text-center otp-title" >Login With Password</p>

                    <TextField
                        id="filled-basic"
                        name="password"
                        type={showPassword ? "text" : "password"}
                        label="Password"
                        variant="filled"
                        value={formvalues.password}
                        onChange={handleChange}
                        style={{ width: "100%", marginTop: "20px", backgroundColor: "#F4F7FE" }}
                        slotProps={{
                            input: {
                                endAdornment: (
                                    <InputAdornment
                                        position="end"
                                        onClick={handleTogglePasswordVisibility}
                                        style={{ cursor: "pointer" }}
                                    >
                                        <img
                                            src={showPassword ? images.viewIcon : images.eyecloseIcon}
                                            alt="toggle visibility"
                                        />
                                    </InputAdornment>
                                ),
                            },
                            inputLabel: {
                                style: { color: "#011627" },
                            },
                        }}
                    />
                    <Grid
                        container
                        rowSpacing={1}
                        columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                        className="pb-3 pt-5"
                        style={{ justifyContent: "space-between" }}
                    >
                        <Grid item size={{ xs: 6 }}>
                            <div
                                onClick={() => onCancelClick()}
                            >
                                <Button title="cancel" classname={"border-btn"} />
                            </div>
                        </Grid>
                        <Grid item size={{ xs: 6 }}>
                            <div
                                onClick={() => handleLoginWithPassword()}
                            >
                                <Button title="Submit" classname={"custom-button"} />
                            </div>
                        </Grid>
                    </Grid>
                    <div className="SignIn-keepLogin-wrap">
                        <div className="keepLogin-wrap">
                            <Checkbox
                                className="signIncheckBox"
                                checked={isChecked}
                                onClick={() => setIsChecked(!isChecked)}
                            />

                            <label for="keepMeLogin" className="keepLogin-label login">
                                Keep me login
                            </label>
                        </div>
                        <div
                            className="forgotPassword-link"
                            style={{ cursor: "pointer" }}
                            onClick={() => navigate("/forgot-password")}
                        >
                            Forgot Password?
                        </div>
                    </div>
                    {/* <ReCAPTCHA
                         ref={recaptchaRef}
                         sitekey={Sitekey}
                         onChange={Recaptchahandle}
                         className="ReCAPTCHA-R pb-3"
                         required
                     /> */}

                    <div className="account-help-links">
                        <div className="link-item">
                            <p onClick={() => navigate("/unlock-account")}>Unlock account?</p>
                        </div>
                    </div>

                    <PrivacyPolicy />
                </Grid>
            </Grid>
            {isLoading && <Loader />}
        </>
    )
}

export default LoginWithPasswordForm;